import { computed, ref, Ref, watch } from '@vue/composition-api';
interface PropAndEmitContext<T> {
  props: T;
  emit: (event: string, ...args: unknown[]) => void;
}

export function useLocalProp<T extends Record<string, unknown>, K extends string> ({ props, emit }: PropAndEmitContext<T>, propName: K, alias?: string): Ref<Readonly<T[K]>> {
  type LocalPropType = T[K];
  const propValue = props[propName];
  const internalValue: Ref<LocalPropType> = ref(propValue);
  watch(() => props[propName], (val) => {
    internalValue.value = val;
  });
  return computed({
    get () {
      return internalValue.value;
    },
    set (val) {
      internalValue.value = val;
      emit(`update:${alias || propName}`, val);
    },
  });
}

export default useLocalProp;
